export const EMAIL_REGEX = /^[(\w.|+)|-]+@([(\w.|+)|-]+\.)+[\w-]{2,10}$/;

export const workflowInProgress = 'Workflow execution is already in progress.';

export const workflowNotReady = 'Workflow is not ready to execute. Please check your configuration.';

export const addAtLeastOneValidNode = 'Add at least one valid node to execute the workflow.';

export const HEADER_HEIGHT = 70;

export const minPasswordLength = 12;

export const maxPasswordLength = 128;

export const minPasswordCharacterTypes = 3;

export const HELLO_MESSAGE = 'Hello! I\'m your AI Agent. How can I help you today?';

export const FAILED_TO_UPDATE_MESSAGE = 'Failed to update the message. Please try again.';

export const WORKFLOW_FAILED = 'Hmm...Something seems to have gone wrong.';

export const DONE_MESSAGE = 'Done. You can review the result.';

export const DRAFT_WORKFLOW_MESSAGE = 'This agent has no workflow components configured. Please configure the agent first.';

export const CONNECTION_ERROR_MESSAGE = 'Connection error. Please refresh the page and try again.';

export const ERROR_MESSAGE = 'An error occurred. Please try again.';

export const REEXECUTE_MESSAGE = 'Reexecuting workflow...';

export const BYTES_PER_KILOBYTE = 1024;

export const ACTIVATE_USER_MESSAGE =
  'This user will regain access to the system and will be able to log in and interact with available features based on their role.';

export const DEACTIVATE_USER_MESSAGE =
  'This user will lose access to the system and won\'t be able to log in until they are reactivated.\n' +
  'Existing data and activity will remain unchanged.';

export const DEFAULT_AGENT_ERROR_MESSAGE = 'The agent failed to complete your request.';
